// Badges pour le rôle d'un membre dans une organisation B2B
// (OrganizationMember.role : OrgAdmin | OrgUser | PendingUser).
// Extrait pour réutilisation (DRY) — auparavant dupliqué inline dans
// organizations/detail.tsx et WorkerCell.tsx.
//
// NB : les libellés courts/pluriels des axes de graphiques (cf.
// dashboard/b2b-roles-bar-card.tsx : "Admins"/"Membres") sont un concern
// distinct (légende de chart) et ne passent volontairement PAS par ce helper.

// Libellés FR par rôle (singulier, pour un badge de membre).
export const ROLE_LABELS_FR: Record<string, string> = {
  OrgAdmin: "Admin organisation",
  OrgUser: "Membre",
  PendingUser: "En attente",
};

const COLORS: Record<string, string> = {
  OrgAdmin: "bg-purple-100 text-purple-800",
  OrgUser: "bg-blue-100 text-blue-800",
  PendingUser: "bg-yellow-100 text-yellow-800",
};

// Rôle inconnu = gris neutre (contrairement aux tiers, un rôle hors-set n'est
// pas une anomalie bloquante — il peut s'agir d'un custom role à venir).
const FALLBACK_COLOR = "bg-gray-100 text-gray-700";

/** Classes Tailwind pour un badge de rôle org (span). */
export function roleBadgeColor(role: string | null | undefined): string {
  if (!role) return FALLBACK_COLOR;
  return COLORS[role] ?? FALLBACK_COLOR;
}

/** Libellé FR lisible d'un rôle org, ou le rôle brut si inconnu, ou "—" si absent. */
export function roleBadgeLabel(role: string | null | undefined): string {
  if (!role) return "—";
  return ROLE_LABELS_FR[role] ?? role;
}
